'use client';

import { createContext } from 'react';

import type { GleamRootContextInterface } from '../types/gleam-root.types';

export const GleamRootContext = createContext<GleamRootContextInterface>({
  hasMultipleChildren: false,
  floatingOffset: undefined,
});

GleamRootContext.displayName = 'Gleam.Root.Context';
